import React from "react";
import "./App.css";

function App() {
  const socialLinks = [
        {
      href: "https://wa.me/+905526525796",
      icon: "https://cdn-icons-png.flaticon.com/512/733/733585.png",
      text: "WhatsApp",
    },
    {
      href: "https://instagram.com/t3k_holster",
      icon: "https://cdn-icons-png.flaticon.com/512/1384/1384063.png",
      text: "Instagram",
    },
    {
      href: "tel:+905526525796",
      icon: "https://cdn-icons-png.flaticon.com/512/724/724664.png",
      text: "Telefon",
    },
    {
      href: "https://taktikol.com",
      icon: "https://cdn-icons-png.flaticon.com/512/841/841364.png",
      text: "Website",
    },
  ];

  return (
    <div className="min-h-screen bg-white flex justify-center px-4 py-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-3xl overflow-hidden text-left">

        {/* Banner + Logo */}
        <div className="relative">
          <img src="/banner.jpg" alt="Banner" className="w-full h-40 object-cover" />
          <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2">
            <div className="w-20 h-20 rounded-full border-4 border-white shadow-md bg-white p-1">
              <img
                src="/taktikol.png"
                alt="Logo"
                className="w-full h-full object-contain rounded-full"
              />
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="pt-14 px-6 pb-6 text-center">
          <h1 className="text-4xl font-bold text-gray-900">T3K Taktikol</h1>
          {/* <p className="text-2xl text-gray-600 mt-1">Taktikol Hayatta Kal!</p> */}
          <p className="text-sm text-gray-600 mt-2">
            Perpa Ticaret Merkezi B Blok Kat:12 No:2134 Şişli / İstanbul
          </p>
          <p className="text-sm font-bold text-gray-600 mt-2">
            Ürün detayları ve iletişim bilgileri için aşağıda ki bağlantıları kullanabilirsiniz.
          </p>

          {/* Bağlantılar */}
          <div className="flex flex-col gap-4 items-start mt-4">
            {socialLinks.map((item, index) => (
              <a
                key={index}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center gap-3 px-4 py-3 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition"
              >
                <img src={item.icon} alt={item.text} className="w-6 h-6" />
                <span className="text-sm font-medium text-gray-800">{item.text}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
